import { render, staticRenderFns } from "./BranchInfo.vue?vue&type=template&id=58941d84&scoped=true&"
import script from "./BranchInfo.vue?vue&type=script&lang=js&"
export * from "./BranchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58941d84",
  null
  
)

export default component.exports